import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { db } from "../../firebase";
import ImageCarousel from "./components/ImageCarousel";
import OwnerInfo from "./components/OwnerInfo";
import "./tag.css";

const Tag = () => {
  const { uid } = useParams();

  const [ownerInfo, setOwnerInfo] = useState({
    ownerName: "",
    contactNo: "",
    emailID: "",
    ownerUid: "",
    profileImg: "",
  });

  const [tagDetails, setTagDetails] = useState({ description: "", images: [] });
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchTagAndOwner() {
      setLoading(true);
      setError(null);
      try {
        const tagRef = doc(db, "tags", uid);
        const tagSnap = await getDoc(tagRef);

        if (!tagSnap.exists()) {
          setError("Tag not found");
          setLoading(false);
          return;
        }
        const tagData = tagSnap.data();
        const ownerId = tagData.owner;
        if (ownerId) {
          const userRef = doc(db, "users", ownerId);
          const userSnap = await getDoc(userRef);

          if (userSnap.exists()) {
            const userData = userSnap.data();
            setOwnerInfo({
              ownerName: userData.name || "Unknown Owner",
              contactNo: userData.contactNo || "N/A",
              emailID: userData.emailID || "N/A",
              ownerUid: userData.uid || "N/A",
              profileImg: userData.profileImg || "",
            });

            if (Array.isArray(userData.tags)) {
              const foundTag = userData.tags.find((t) => t && t.id === uid);
              if (foundTag) {
                setTagDetails({
                  description: foundTag.description || "",
                  images: foundTag.images || tagData.images || [],
                });
                return;
              }
            }
          }
        }

        setTagDetails({
          description: tagData.description || "",
          images: tagData.images || [],
        });
      } catch (err) {
        console.error("Error fetching tag/owner:", err);
        setError("Error fetching tag or owner");
      } finally {
        setLoading(false);
      }
    }
    if (uid) fetchTagAndOwner();
  }, [uid]);

  useEffect(() => {
    setCurrentImageIndex(0);
  }, [tagDetails.images]);

  return (
    <div className="tag-page">
      <Header title="Tag Details" buttons={[{ to: "/", label: "Home" }]} />
      <main className="item-content">
        {loading ? (
          <div className="loading">Loading...</div>
        ) : error ? (
          <div className="error">{error}</div>
        ) : (
          <>
            <ImageCarousel
              images={tagDetails.images}
              currentIndex={currentImageIndex}
              setCurrentIndex={setCurrentImageIndex}
            />
            <div className="tag-description">
              {tagDetails.description || "No description available."}
            </div>
            <OwnerInfo {...ownerInfo} />
          </>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default Tag;
